import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';
import { Icon, type IconName } from './Icon.js';
import { useDueDraftsCount } from '../hooks/useLeads.js';

const NAV_ITEMS: Array<{ to: string; labelKey: string; icon: IconName }> = [
  { to: '/', labelKey: 'nav.home', icon: 'home' },
  { to: '/email', labelKey: 'nav.email', icon: 'email' },
  { to: '/leads', labelKey: 'nav.leads', icon: 'leads' },
  { to: '/contacts', labelKey: 'nav.contacts', icon: 'contacts' },
  { to: '/proyectos', labelKey: 'nav.projects', icon: 'projects' },
  { to: '/reports', labelKey: 'nav.reports', icon: 'activity' },
  { to: '/tasks', labelKey: 'nav.tasks', icon: 'bolt' },
  { to: '/facturacion', labelKey: 'nav.facturacion', icon: 'facturacion' },
  { to: '/settings', labelKey: 'nav.settings', icon: 'settings' },
];

interface SidebarProps {
  collapsed: boolean;
}

export function Sidebar({ collapsed }: SidebarProps) {
  const { t } = useTranslation();
  const { data: dueData } = useDueDraftsCount();
  const dueCount = dueData?.count ?? 0;

  return (
    <aside
      className="flex flex-col shrink-0"
      style={{
        width: collapsed ? '80px' : '200px',
        background: 'var(--evo-bg-3)',
        borderRight: '1px solid var(--evo-stroke)',
        transition: 'width 180ms ease',
        overflow: 'hidden',
      }}
    >
      <nav className="flex-1 px-3 py-4 space-y-1">
        {NAV_ITEMS.map(({ to, labelKey, icon }) => {
          const isLeads = to === '/leads';
          return (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              title={collapsed ? t(labelKey) : undefined}
              className={({ isActive }) => clsx('nav-link', isActive && 'active')}
              style={collapsed ? { justifyContent: 'center', gap: 0, paddingLeft: 0, paddingRight: 0, position: 'relative' } : {}}
            >
              <Icon name={icon} size={18} />
              {!collapsed && (
                <span style={{ fontFamily: 'var(--evo-font)', flex: 1 }}>{t(labelKey)}</span>
              )}
              {isLeads && dueCount > 0 && !collapsed && (
                <span style={{
                  display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                  minWidth: '18px', height: '18px', padding: '0 5px',
                  borderRadius: '9px', fontSize: '10px', fontWeight: 700,
                  background: 'var(--evo-cyan)', color: '#0a0a0a',
                  fontFamily: 'var(--evo-font)', lineHeight: 1, flexShrink: 0,
                }}>
                  {dueCount}
                </span>
              )}
              {isLeads && dueCount > 0 && collapsed && (
                <span style={{
                  position: 'absolute', top: '4px', right: '4px',
                  width: '8px', height: '8px', borderRadius: '50%',
                  background: 'var(--evo-cyan)',
                }} />
              )}
            </NavLink>
          );
        })}
      </nav>
    </aside>
  );
}
